import React, { Component } from 'react';
import { Layout } from './Layout';

export class Dashboard extends Component {
    static displayName = Dashboard.name;

    render() {
        return (
            <Layout>
                <iframe title="victron" width="100%" height="1000" src="https://vrm.victronenergy.com/installation/149887/embed/da7a171d"></iframe>
            </Layout>
        );
    }
}
